<template>
    <div class="modal fade" id="arquivo_digital_delete_modal" data-backdrop="static">
        <div class="modal demo-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <b>Deletar</b>
                        </h5>
                        <!-- <button type="button" class="close">
                            <span aria-hidden="true">×</span>
                        </button> -->
                    </div>
                    <div class="modal-body"> 

                        <dot :isVisible="isLoading"></dot>

                        <div v-if="!isLoading">
                            Deseja realmente DELETAR o <b>ARQUIVO</b>?
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-danger"
                            @click.prevent.stop="deleteArquivoDigital">
                            Deletar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	import { eventBus } from '../../app';
    import Dot from '../loadder/Dot.vue';

    export default {

    	components: {
            Dot
        },


    	data(){
            return {
                currentPagePagination: null,

            	isLoading: false,

                //ARRAYS
            	errors: [],

                //OBJECTS
                delete_arquivo_digital: {}
            }
        },

        mounted(){
        	this.registryEventOpenModalDeleteArquivoDigital();
        },

        methods: {
            registryEventOpenModalDeleteArquivoDigital(){
                eventBus.$on('eventOpenModalDeleteArquivoDigital', (deleteArquivoDigital, currentPage) => {
                	this.errors = [];
                    this.delete_arquivo_digital = Object.assign({}, deleteArquivoDigital);
                    this.currentPagePagination = currentPage;
                    $("#arquivo_digital_delete_modal").modal("show");
                });
            },

            emitEventGetArquivosDigital(){
                eventBus.$emit('eventGetArquivosDigital', this.currentPagePagination);
            },

            deleteArquivoDigital()
            {
                this.isLoading = true;
                axios.delete(
                    '/arquivodigital/' + this.delete_arquivo_digital.id
                )
                .then(response => {
                    this.isLoading = false;
                    $("#arquivo_digital_delete_modal").modal("hide");
                    toastr.success(response.data.message);
                    this.emitEventGetArquivosDigital();
                })
                .catch(error => {
                    this.isLoading = false;
                    let erroObject = error.response.data;
                    if(erroObject.message)
                    {
                        toastr.error(erroObject.message);
                    }
                });
            }

            
            
        }
    }
</script>